/**
 * Can be used to remove undefined values inside a filter function
 * Example: ``
 *   const packageIds = packages?.map((a) => a.package?.id).filter(removeNullAndUndefined);
 * ``
 */
export const removeNullAndUndefined = <T>(value: T | undefined | null): value is T =>
  value !== undefined && value !== null;
